import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const regenerateDiscoveryTree = (orgId, treeId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'TRIGGERING_TREE_REGENERATION' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/org/${orgId}/discovery-tree`,
            payload,
            {
              params: {
                'request-id': reqId,
                treeId: treeId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'TRIGGERING_TREE_REGENERATION_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'TRIGGERING_TREE_REGENERATION_FAILED',
              payload: `Failed to export discovery tree`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'TRIGGERING_TREE_REGENERATION_FAILED',
            payload: `Failed to export discovery tree`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'TRIGGERING_TREE_REGENERATION_FAILED',
        payload: `Failed to export discovery tree`,
      });
    }
  };
};

export default regenerateDiscoveryTree;
